import { getObjectUtil } from 'packages/src'

function getErrorReduxUtil (instance) {
  return getObjectUtil(instance, 'error')
}

export default getErrorReduxUtil
